module.exports = __webpack_public_path__ + "media/images/country_flags/kn-5023d96eb67d1b7ab1bafc2074c8451e.png";